import EditUserSumsubLevel from './EditUserSumsubLevel';

export default EditUserSumsubLevel;
